const css = `.RwUkQW__insetShadowContainer{overflow-y:auto}.RwUkQW__insetShadow:before{content:"";width:100%;height:100%;pointer-events:none;display:block;position:absolute;top:0;left:0;box-shadow:inset 0 -18px 10px -15px #0000003b}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"insetShadowContainer":"RwUkQW__insetShadowContainer","insetShadow":"RwUkQW__insetShadow"};
